import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/salesData';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="border-b border-[var(--olive)]/30 py-16 sm:py-20" data-id="element-54" data-mp="1bmven0vw6est">
      <div className="mx-auto max-w-3xl px-4" data-id="element-55" data-mp="1gjvjx9kx3div">
        <SectionHeading eyebrow="❓ Lo que más nos preguntan" data-id="element-56" data-mp="248o6wgjkab1c">
          Preguntas frecuentes
        </SectionHeading>

        <div className="mt-10 space-y-3" data-id="element-57" data-mp="289q8h40yaz6h">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} className="overflow-hidden rounded-xl border border-[var(--olive)]/40 bg-[#0d0f08]" data-id="element-58" data-mp="1uhadmqi7e7gn" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 p-5 text-left transition-colors hover:bg-white/[0.02] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--gold)]/40" data-id="element-59" data-mp="2n7a95yqte86u">
                  <span className="font-semibold text-[var(--cream)]" data-id="element-60" data-mp="1eldfcrxe5tey">
                    {faq.question}
                  </span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-[var(--gold)]" aria-hidden="true" data-id="element-61" data-mp="1oj9m77jaq279" /> : <PlusIcon className="h-5 w-5 shrink-0 text-[var(--gold)]" aria-hidden="true" data-id="element-62" data-mp="1jmj64k7hr6lu" />}
                </button>
                {isOpen && <p className="px-5 pb-5 text-white/70" data-id="element-63" data-mp="35f026bmeb5a">{faq.answer}</p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}